import { OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
var INDRASelectInputComponent = /** @class */ (function () {
    function INDRASelectInputComponent() {
        this.arialabel = '';
        this.placeholderKey = '';
        this.required = false;
        this.inputValue = '';
        this.inputOptions = [
            {
                value: String,
                label: String
            }
        ];
        this.disabled = false;
        this.parentForm = null;
        this.formGroupName = null;
        this.formControlName = null;
        this.is_unselected = false;
        this.is_open = false;
        this.isAlive = true;
        // Function to call when the rating changes.
        this.onChange = function (value) { };
        // Function to call when the input is touched (when a star is clicked).
        this.onTouched = function () { };
    }
    Object.defineProperty(INDRASelectInputComponent.prototype, "value", {
        get: function () {
            return this.inputValue;
        },
        // set accessor including call the onchange callback
        set: function (v) {
            if (v !== this.inputValue) {
                this.inputValue = v;
                this.onChange(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    INDRASelectInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.is_unselected = this.placeholder !== undefined && (this.inputValue === (null || ''));
        if (this.parentForm) {
            if (this.parentForm.get(this.formControlName).value) {
                this.is_unselected = false;
            }
            this.parentForm.get(this.formControlName).valueChanges
                .pipe(takeWhile(function () { return _this.isAlive; }))
                .subscribe(function (value) {
                if (value == null) {
                    _this.is_unselected = true;
                    _this.handleSelectChange();
                }
                /*
                if (value == null) {
                    this.is_unselected = true;
                } else {
                    this.is_unselected = false;
                }
                this.handleSelectChange();
                */
            });
        }
        else if (this.inputValue === '') {
            this.inputValue = null;
        }
    };
    INDRASelectInputComponent.prototype.hasLabel = function () {
        return this.label !== undefined;
    };
    INDRASelectInputComponent.prototype.printLabel = function () {
        return this.label;
    };
    INDRASelectInputComponent.prototype.hasPlaceholder = function () {
        return this.placeholder !== undefined && this.is_unselected;
    };
    INDRASelectInputComponent.prototype.printPlaceholder = function () {
        return this.placeholder;
    };
    INDRASelectInputComponent.prototype.printPlaceholderKey = function () {
        return this.placeholderKey;
    };
    /**
     * @returns styles for select wrapper
     */
    INDRASelectInputComponent.prototype.INDRA_selectWrapperStyles = function () {
        var result = [];
        if (this.is_open)
            result.push('is-open');
        if (this.disabled)
            result.push('is-disabled');
        if (this.hasPlaceholder())
            result.push('is-unselected');
        return result.join(' ');
    };
    /**
     * @returns styles for select
     */
    INDRASelectInputComponent.prototype.INDRA_selectStyles = function () {
        return {
            'is-unselected': this.hasPlaceholder(),
            'has-error': this.hasError
        };
    };
    INDRASelectInputComponent.prototype.handleSelectChange = function () {
        this.is_open = false;
        if (this.is_unselected && (this.inputValue !== (null || ''))) {
            this.is_unselected = false;
        }
    };
    INDRASelectInputComponent.prototype.handleSelectClick = function () {
        this.is_open = true;
    };
    INDRASelectInputComponent.prototype.handleSelectBlur = function () {
        this.is_open = false;
    };
    INDRASelectInputComponent.prototype.change = function ($event) {
        this.inputValue = $event.target.value;
        if (this.parentForm)
            this.parentForm.get(this.formControlName).setValue(this.inputValue);
        this.handleSelectChange();
    };
    Object.defineProperty(INDRASelectInputComponent.prototype, "INDRA_printID", {
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRASelectInputComponent.prototype, "INDRA_showError", {
        get: function () {
            return this.hasError;
        },
        enumerable: true,
        configurable: true
    });
    // Allows Angular to update the model (rating).
    // Update the model and changes needed for the view here.
    INDRASelectInputComponent.prototype.writeValue = function (value) {
        this.onChange(value);
    };
    // Allows Angular to register a function to call when the model (rating) changes.
    // Save the function as a property to call later here.
    INDRASelectInputComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    INDRASelectInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // Allows Angular to disable the input.
    INDRASelectInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    INDRASelectInputComponent.prototype.INDRA_printError = function () {
        return this.errorMessage;
    };
    INDRASelectInputComponent.prototype.INDRA_isRequired = function () {
        return this.required;
    };
    INDRASelectInputComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    return INDRASelectInputComponent;
}());
export { INDRASelectInputComponent };
